import { useEffect } from 'react';

export const useFavicon = (faviconUrl) => {
  useEffect(() => {
    if (!faviconUrl) return;

    // Get all existing favicon links
    const links = document.querySelectorAll('link[rel*="icon"]');
    
    // Remove old favicon links
    links.forEach(link => link.remove());

    // Create new favicon link
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = faviconUrl;
    document.head.appendChild(link);

    // Also create apple-touch-icon
    const appleLink = document.createElement('link');
    appleLink.rel = 'apple-touch-icon';
    appleLink.href = faviconUrl;
    document.head.appendChild(appleLink);

  }, [faviconUrl]);
};
